import React from 'react'
import { RotatingLines } from 'react-loader-spinner';
import { currency, getBodyType } from '../../../../common/services/common.service';

export default function ModalQuotesDetailsComponent({
    handleBookLater, selectedVehicleItem, dropLocations, pickupLocations, quoteDetails, enablePlaceOrder, handlePayment, isLoading, paymentSettings, paymentSelectedInput, handlePaymentInput }: any) {

    const items = [
        {
            name: 'Cash',
            description: 'Cash on delivery',
            value: 10,
            checked: '',
            imageUrl: require('../../../../assets/img/cash.png'),
            show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForCOD,

        },
        {
            name: 'Online',
            description: 'Payment gateway',
            value: 20,
            checked: 'checked',
            imageUrl: require('../../../../assets/img/ccAvenue.png'),
            show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForOnline,
        },
        {
            name: 'Wallet',
            description: 'Wallet',
            value: 40,
            checked: '',
            imageUrl: require('../../../../assets/img/wallet.png'),

        },
    ];


    return (

        <div className="w-full p-4 bg-white ">
            <h1 className="text-xl font-semibold mb-4 text-center">Confirm Order</h1>

            {/* Order Details */}
            <div>
                <h2 className="px-4 text-lg font-semibold mb-4">Order Details</h2>
                <div className="grid grid-cols-3 gap-4 px-4">
                    <div>
                        <label className="text-base font-medium text-gray-800">Vehicle Type</label>
                        <p className="text-sm font-medium text-gray-600">{getBodyType(selectedVehicleItem?.VehicleBodyTypeId)}</p>
                    </div>
                    <div>
                        <label className="text-base font-medium text-gray-800">Total Distance</label>
                        <p className="text-sm font-medium text-gray-600">{quoteDetails?.result?.Records[0]?.message?.order?.quote?.TotalDistance} km</p>
                    </div>
                    <div>
                        <label className="text-base font-medium text-gray-800">Amount Quoted</label>
                        <p className="text-sm font-medium text-gray-600">{currency(quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.value)}</p>
                    </div>

                </div>
                <div className="border-b border-gray-300 py-2" />
                <div className="grid grid-cols-1 gap-4 pt-2 px-4">

                    <div>
                        <label className="text-base font-medium text-gray-800">Pickup Address</label>
                        <p className="text-sm font-medium text-gray-600">{pickupLocations?.description}</p>
                    </div>
                    <div>
                        <label className="text-base font-medium text-gray-800">Drop Address</label>
                        <p className="text-sm font-medium text-gray-600">{dropLocations?.description}</p>
                    </div>
                </div>
                <div className="border-b border-gray-300 py-2" />
            </div>

            {/* Payment Details */}
            <div className="p-4">
                <h2 className="text-lg font-semibold mb-4">Payment Details</h2>
                <p className="text-base font-medium text-gray-800">Payment Method</p>
                <div className="grid grid-cols-4 gap-4 pt-2">
                    {items?.map((item, index) => (
                        item.show && (
                            <div key={index} className="flex flex-row w-full items-center">
                                <div>
                                    <input
                                        name={item?.name}
                                        type="radio"
                                        placeholder=""
                                        checked={paymentSelectedInput == String(item?.name)}
                                        className={`mx-3  rounded bg-opacity-0 cursor-pointer transform scale-150`}
                                        onChange={(event: any) => {
                                            handlePaymentInput(event, item)
                                            //   handleFormItemChange({
                                            //     value: item?.name,
                                            //     idx: index,
                                            //     field: 'paymentType' // Changed field name to 'paymentType' for consistency
                                            //   })
                                        }}
                                        value={item?.name}
                                    /> </div>

                                <div className='text-sm font-medium text-gray-600'>
                                    {item?.name}
                                </div>

                            </div>
                        )
                    ))}
                </div>

                {/* Action Buttons */}
                <div className="flex justify-end space-x-4 mt-6">
                    <button onClick={handleBookLater} className="px-4 py-2 bg-primary text-light rounded-md hover:bg-slate-500">
                        Book Later
                    </button>
                    <button
                        onClick={handlePayment}
                        className={`px-6 py-2 text-white rounded-md flex items-center justify-center transition-all relative ${paymentSelectedInput === 'Cash' ? 'w-40' : 'w-52'}
                   ${isLoading ? 'bg-gray-400 cursor-not-allowed ' : enablePlaceOrder ? 'bg-primary hover:bg-slate-500' : 'bg-slate-500 cursor-not-allowed'}`}
                        disabled={!enablePlaceOrder || isLoading}
                    >
                        {paymentSelectedInput === 'Cash' ? 'Place Order' : 'Make a Payment'}
                        {isLoading && (
                            <span className="absolute right-4">
                                <RotatingLines
                                    visible={true}
                                    width={'20'}
                                    strokeColor="#fff"
                                    strokeWidth="6"
                                    animationDuration="0.75"
                                    ariaLabel="rotating-lines-loading"
                                />
                            </span>
                        )}
                    </button>
                </div>
            </div>
        </div>





    )
}